import PuzzleFences from './Root.vue';
import PuzzleFencesCreate from './views/PuzzleFencesCreate.vue';
import PuzzleFencesEdit from './views/PuzzleFencesEdit.vue';
import PuzzleFencesList from './views/PuzzleFencesList.vue';

export default {
  path: 'gerador/fences',
  name: 'admin-puzzle-fences',
  component: PuzzleFences,
  redirect: '/novo',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-puzzle-fences-list',
      component: PuzzleFencesList,
    },
    {
      path: 'novo/',
      name: 'admin-puzzle-fences-new',
      component: PuzzleFencesCreate,
    },
    {
      path: ':puzzleId',
      name: 'admin-puzzle-fences-edit',
      component: PuzzleFencesEdit,
    },
  ],
};
